export enum I18nNamespace {
  common = 'common',
  countries = 'countries',
  negotiationHistory = 'negotiationHistory',
  issues = 'issues',
  tasks = 'tasks',
  validation = 'validation',
  widgets = 'widgets',
  recommendation = 'recommendation',
  languages = 'languages',
  intake = 'intake',
  intakeCore = 'intakeCore',
  businessLog = 'businessLog',
  knowledgeGraph = 'knowledgeGraph',
  knowledgeRepository = 'knowledgeRepository',
  riskSustainability = 'riskSustainability',
  base = 'base',
  demand = 'demand',
  ruleBuilder = 'ruleBuilder',
  cockpit = 'cockpit',
  modules = 'modules',
  conversation = 'conversation',
  agents = 'agents',
}
